import { useEffect } from 'react'
import { getPrivilegeMemberRelationshipProps, getPrivilegePartyMembers, getPrivilegePartys, getPrivilegeRoles, getPrivilegeRolesElements } from '../../../services/sPrivilege/privilege.service';
import { isNullOrEmpty, isNullUndefined, treeify } from '../../../common/Helpers';
import { forEach } from 'lodash-es';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import { enum__BOARD_TEMPLATE_TYPE } from '../../../common/Dictionaries';

const useGetPrivilegeRoles = (privileges, setPrivileges, inputParam_IsPanelOpen) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getPrivilegeRoles();
                const response = serviceResponse.data;

                setPrivileges && setPrivileges(response.data);
            }
            catch (error) {
            }
        }
        
        if (privileges === null && inputParam_IsPanelOpen) {
            getData()
        }
    }, [privileges, setPrivileges, inputParam_IsPanelOpen]);
}

const useGetPrivilegeRolesElementsDropDown = (elementId, privileges, setPrivileges, inputParam_IsPanelOpen, selectecValue, setSelectedElementRole) => {
    const { t } = useTranslation();
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getPrivilegeRolesElements(elementId);

                if (serviceResponse.data.succeeded) {
                    const response = serviceResponse.data.data.map((item, index) => {
                        return {
                            id: item.id,
                            key: item.id,
                            text: item.name,
                            name: item.name,
                            description: item.description,
                            selected: selectecValue !== undefined ? item.name === selectecValue : false,
                            disabled: item.deavtivate !== null ? item.deavtivate : false,
                            isExternal: isNullUndefined(item.isExternal) ? false : (item.isExternal === true ? true : false),
                            code: item.privlegeRoleCode
                        };
                    })
                    response.unshift({
                        id: 0,
                        key: 0,
                        text: t("data-lang-lbl-select"),
                        name: t("data-lang-lbl-select"),
                        description: "",
                        selected: selectecValue !== undefined ? false : true,
                        disabled: false,
                        isExternal: null,
                        code: ""
                    })
                    setSelectedElementRole && setSelectedElementRole(serviceResponse.data.data.find(x => x.privlegeRoleCode === selectecValue) ?? null)  
                    setPrivileges && setPrivileges(response); 
                }
                else {
                    setPrivileges && setPrivileges([]);   
                }            
            }
            catch (error) {
                setPrivileges && setPrivileges([]);   
            }
        }
        
        if (privileges === null && inputParam_IsPanelOpen) {
            getData()
        }
    }, [privileges, setPrivileges, inputParam_IsPanelOpen, selectecValue]);
}

const useGetPrivilegePartyMembers = (elementId, elementPrivileges, setElementPrivileges, setBasePrivilegeList, inputParam_IsPanelOpen) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getPrivilegePartyMembers(elementId);
                const response = serviceResponse.data;

                if (response.succeeded) {
                    setElementPrivileges && setElementPrivileges(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: response.data
                    }));
                    setBasePrivilegeList && setBasePrivilegeList(JSON.parse(JSON.stringify(response.data)))
                }
                else {
                    setElementPrivileges && setElementPrivileges(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: []
                    }));
                    setBasePrivilegeList && setBasePrivilegeList([])
                }
            }
            catch (error) {
                setElementPrivileges && setElementPrivileges(prevState => ({
                    ...prevState,
                    fireUpdate: true,
                    data: []
                }));
                setBasePrivilegeList && setBasePrivilegeList([])
            }
        }
        
        if (elementPrivileges === null && elementId !== null && inputParam_IsPanelOpen) {
            getData()
        }
    }, [elementPrivileges, setElementPrivileges, setBasePrivilegeList, inputParam_IsPanelOpen]);
}

const useGetPrivilegePartyMembersCustom = (elementId, usersArray, setUsersArray, selectInitialData, initialIdsDataArray, isPanelOpen, isTreeify) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getPrivilegePartyMembers(elementId);

                if (serviceResponse.data.succeeded) {
                    if (isTreeify) {
                        let aux_users = []

                        serviceResponse.data.data.forEach(user => {
                            user.fullname = user.legalEntityCode + ": " + user.fullname;
                            aux_users.push(user)
                        });

                        serviceResponse = treeify(serviceResponse !== null ? aux_users : [], 'id', null, 'children', null, 'fullname');
    
                        if (selectInitialData) {
                            serviceResponse.forEach(element => {
                                initialIdsDataArray.forEach(id => {
                                    if (element.username === id) {
                                        element.checked = true;
                                    }
                                });
                            });
                        }

                        setUsersArray && setUsersArray(serviceResponse)
                    }
                    else {
                        setUsersArray && setUsersArray(prevState => ({
                            ...prevState,
                            fireUpdate: true,
                            data: serviceResponse.data.data
                        }));
                    }
                }
                else {
                    setUsersArray && setUsersArray(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: []
                    }));
                }
            }
            catch (error) {
                if (isTreeify) {
                    setUsersArray && setUsersArray([])
                }
                else {
                    setUsersArray && setUsersArray(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: []
                    }));
                }
            }
        }
        
        if ((elementId !== null && ((usersArray === null)) && isPanelOpen) && (selectInitialData === true ?  ((initialIdsDataArray !== null)? initialIdsDataArray.length > 0 : true) : true)) {
            getData()
        }
    }, [elementId, usersArray, setUsersArray, selectInitialData, initialIdsDataArray, isPanelOpen, isTreeify]);
}

const useGetPrivilegePartys = (elementId, privileges, setPrivileges, inputParam_IsPanelOpen) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getPrivilegePartys(elementId);
                const response = serviceResponse.data;

                if (response.succeeded) {
                    const _response = response.data.map((item, index) => {
                        return {
                            id: item.id,
                            key: item.id,
                            text: item.name,
                            name: item.name,
                            manager: item.manager,
                            selected: false,
                        };
                    })

                    setPrivileges && setPrivileges(_response);
                }
                else {
                    setPrivileges && setPrivileges([]);

                }
            }
            catch (error) {
                setPrivileges && setPrivileges([]);
            }
        }
        
        if (elementId !== null && privileges === null && inputParam_IsPanelOpen) {
            getData()
        }
    }, [elementId, privileges, setPrivileges, inputParam_IsPanelOpen]);
}

const useGetUserPropsKpi = (tipoBoardId, boardId, elementId, username, userPropsKpi, setUserProps) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                if (tipoBoardId !== enum__BOARD_TEMPLATE_TYPE.NONE) {
                    let serviceResponse = await getPrivilegeMemberRelationshipProps(tipoBoardId, boardId, elementId, username.split('\\')[1]);
                    let response = serviceResponse.data;

                    if (response.succeeded) {
                        if (response.data.hasAccess === false) {
                            window.location.href = '/NoDataAccess'
                        }
                        else {
                            setUserProps(response.data);
                        }
                    }
                    else {
                        setUserProps({hasAccess : false, onlyObserver: false})
                    }
                }
                else {
                    setUserProps({hasAccess : false, onlyObserver: false})
                }
            }
            catch (error) {
                setUserProps({hasAccess : false, onlyObserver: false})
            }
        }
        
        if (username !== null && userPropsKpi.hasAccess === null) {
            getData()
        }

    }, [tipoBoardId, boardId, elementId, username, userPropsKpi, setUserProps]);
}

const useGetUserPropsExternalLanding = (tipoBoardId, boardId, elementId, username, userPropsKpi, setUserProps) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getPrivilegeMemberRelationshipProps(tipoBoardId, boardId, elementId, username.split('\\')[1]);
                let response = serviceResponse.data;

                if (response.succeeded) {
                    //response.data.l_roles = [{elementId: 2, roleId: 3, l_variables: []}]
                    setUserProps(response.data);
                }
                else {
                    setUserProps({hasAccess : false, onlyObserver: false})
                }
            }
            catch (error) {
                setUserProps({hasAccess : false, onlyObserver: false})
            }
        }
        
        if ((boardId !== 0 && boardId !== undefined) && !isNullUndefined(elementId) && username !== null && userPropsKpi.hasAccess === null) {
            getData()
        }

    }, [tipoBoardId, boardId, elementId, username, userPropsKpi, setUserProps]);
}


export {
    useGetUserPropsKpi,
    useGetPrivilegeRoles,
    useGetPrivilegeRolesElementsDropDown,
    useGetPrivilegePartyMembers,
    useGetPrivilegePartyMembersCustom,
    useGetPrivilegePartys,
    useGetUserPropsExternalLanding
}